import { render, staticRenderFns } from "./ReceberNotasManifestoModal.vue?vue&type=template&id=3ba9071b"
import script from "./ReceberNotasManifestoModal.vue?vue&type=script&lang=js"
export * from "./ReceberNotasManifestoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports